import * as css from './css';
export { AnimationFrameRequest } from './animation-frame-request';
export * as file from './file';
export * from './size-observable';
export * from './rendering-context/canvas-rendering-context-2d-ext';
export * from './rendering-context/rendering-context-2d';
export * from './rendering-context/svg-rendering-context-2d';
export { css };

declare global{
	interface NodeListOf<TNode extends Node> extends NodeList {
		keys():Iterator<number>;
		values():Iterator<TNode>;
		entries():Iterator<[number,TNode]>;
		[Symbol.iterator]():Iterator<TNode>;
	}
}
